import { JOURNEY_BUILDER } from 'constants/actionTypes';

const initialState = {
  dropElement: null,
  showEditDetails: false,
};

export default (state = initialState, action = {}) => {
  const updateState = changes => ({ ...state, ...changes });

  switch (action.type) {
    case JOURNEY_BUILDER.UI.TOGGLE_PREVIEW:
      return updateState({
        previewing: !state.previewing,
      });
    case JOURNEY_BUILDER.UI.SHOW_EDIT_DETAILS:
      return updateState({
        showEditDetails: true,
      });
    case JOURNEY_BUILDER.UI.HIDE_EDIT_DETAILS:
      return updateState({
        showEditDetails: false,
      });
    default: {
      return state;
    }
  }
};
